var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4009 0.535638C13.2724 0.452235 13.1287 0.394967 12.978 0.367105C12.8274 0.339244 12.6727 0.341335 12.5229 0.37326C12.3731 0.405185 12.231 0.466317 12.1048 0.553165C11.9786 0.640013 11.8707 0.750874 11.7874 0.879416L5.25016 10.9559L2.06205 8.00814C1.94957 7.90413 1.8177 7.82331 1.67398 7.77026C1.53026 7.71722 1.37751 7.69301 1.22443 7.699C0.915274 7.71111 0.623592 7.84553 0.413548 8.07269C0.203504 8.29986 0.0923035 8.60116 0.10441 8.91031C0.116517 9.21947 0.250938 9.51115 0.478103 9.72119L4.6641 13.5914C4.6641 13.5914 4.78427 13.6949 4.83988 13.731C4.9684 13.8145 5.11211 13.8718 5.2628 13.8997C5.41348 13.9276 5.56819 13.9255 5.71807 13.8936C5.86795 13.8617 6.01007 13.8005 6.13631 13.7136C6.26254 13.6268 6.37042 13.5158 6.45377 13.3872L13.7447 2.14914C13.8281 2.02063 13.8853 1.87695 13.9132 1.72631C13.9411 1.57566 13.939 1.421 13.907 1.27117C13.8751 1.12133 13.814 0.979253 13.7271 0.853049C13.6403 0.726845 13.5294 0.618987 13.4009 0.535638Z",
    fill: "#02593D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMark);
export default __webpack_public_path__ + "static/media/check-mark.fdb3ea49.svg";
export { ForwardRef as ReactComponent };